import React from "react";
import { Button } from "components/ui/button";
import { WandSparkleIcon, FigmaIcon } from "./icons";

const FIGMA_PLUGIN_URL =
  "https://www.figma.com/community/plugin/1609266944915750859/oppizi-frames-design-and-launch-high-performing-offline-ads";

interface CreatePaneProps {
  onOpenCreativeStudio: () => void;
  isOpeningCreativeStudio?: boolean;
}

const OptionRow = ({
  icon,
  title,
  badge,
  description,
  actionLabel,
  onAction,
  disabled,
}: {
  icon: React.ReactNode;
  title: string;
  badge?: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
}) => (
  <div className="border-border flex items-center gap-3 rounded-lg border border-solid bg-card p-4">
    <div className="bg-muted text-slate-600 dark:text-slate-300 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg">
      {icon}
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <div className="flex items-center gap-2">
        <p className="text-foreground text-sm font-semibold leading-5">{title}</p>
        {badge && (
          <span className="rounded-full bg-success px-2 py-0.5 text-xs font-medium text-success-foreground">
            {badge}
          </span>
        )}
      </div>
      <p className="text-muted-foreground text-xs leading-4">{description}</p>
    </div>
    <Button type="button" variant="outline" onClick={onAction} disabled={disabled} className="shrink-0 rounded-lg">
      {actionLabel}
    </Button>
  </div>
);

export const CreatePane: React.FC<CreatePaneProps> = ({ onOpenCreativeStudio, isOpeningCreativeStudio }) => (
  <div className="flex flex-col gap-2">
    <p className="text-foreground text-sm font-medium leading-5">Create new</p>
    <OptionRow
      icon={<WandSparkleIcon className="text-muted-foreground h-5 w-5" />}
      title="Creative Studio"
      badge="Recommended"
      description="Design your flyer with our AI powered tool."
      actionLabel="Open Creative Studio"
      onAction={onOpenCreativeStudio}
      disabled={isOpeningCreativeStudio}
    />
    <div className="flex items-center gap-3">
      <div className="bg-slate-200 dark:bg-accent h-px flex-1" />
      <span className="text-muted-foreground text-xs font-medium">OR</span>
      <div className="bg-slate-200 dark:bg-accent h-px flex-1" />
    </div>
    <OptionRow
      icon={<FigmaIcon className="text-foreground h-5 w-5" />}
      title="Figma Plugin"
      description="Design flyers directly in Figma."
      actionLabel="Open plugin"
      onAction={() => window.open(FIGMA_PLUGIN_URL, "_blank", "noopener,noreferrer")}
    />
  </div>
);
